import { Component, Output, EventEmitter, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Globals } from '../../../services/globals';

interface Crumb {
  description: string;
  path: string;
  pathIndex: number;
  selected: boolean;
  icon: string;
  component: string;
}

@Component({
  selector: 'app-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styleUrls: ['./breadcrumbs.component.css']
})
export class BreadcrumbsComponent implements OnInit {
  @Output() indexChangedEvent = new EventEmitter<number>();
  selectedIndex: number;

  crumbs: Crumb[] = [
    {
      description: "Welcome",
      path: "welcome",
      pathIndex: 0,
      selected: true,
      icon: "fa-circle",
      component: "welcome"
    },
    {
      description: "Inspiration",
      path: "inspiration",
      pathIndex: 1,
      selected: false,
      icon: "fa-circle",
      component: "inspiration"
    },
    {
      description: "Selections",
      path: "selections",
      pathIndex: 2,
      selected: false,
      icon: "fa-circle",
      component: "selections"
    },
    {
      description: "Review",
      path: "review",
      pathIndex: 3,
      selected: false,
      icon: "fa-star",
      component: "review"
    }
  ];

  constructor(private route: ActivatedRoute, private router: Router, public globals: Globals) { }

  selectIndex(index: number) {
    if (this.globals.syncingOptions) {
      return;
    }
    const selectedObject = this.crumbs.filter(q => q.selected)[0];

    selectedObject.selected = false;

    this.crumbs[index].selected = true;

    this.indexChangedEvent.emit(index);

    // Adding a component property to the  object will accomplish the same:
    this.router.navigate([this.crumbs[index].component]);

    this.markSelected();
  }

  ngOnInit() {
this.markSelected();
 }

  markSelected() {
    for (const crumb of this.crumbs) {
      if (this.router.url.includes(`/${crumb.path}`)) {
        for (let i = 0; i <= crumb.pathIndex; i++) {
          this.crumbs[i].selected = true;
          this.selectedIndex = crumb.pathIndex;
 }
 }
    }
  }
}
